import { render, staticRenderFns } from "./cardconfirmation.vue?vue&type=template&id=4b5df64e&scoped=true"
import script from "./cardconfirmation.vue?vue&type=script&lang=js"
export * from "./cardconfirmation.vue?vue&type=script&lang=js"
import style0 from "./cardconfirmation.vue?vue&type=style&index=0&id=4b5df64e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5df64e",
  null
  
)

export default component.exports